import {
  SET_LOADING_MESSAGES,
  SET_FILTER_MESSEAGES,
  UNSET_LOADING_MESSAGES,
  SET_FAILURE_MESSAGES,
  SET_LIST_MESSAGES,
  SET_LOADING_DELETE,
  SET_FAILURE_DELETE,
  SET_SUCCESS_DELETE,
  ADD_TO_LIST_MESSAGES,
  RESTE_ALL_MESSAGES_LIST_DATA_APP,
  SEEN_MESSAGE_ITEM_COUNT,
  SET_LIST_SESSION,
  SET_LOADING_SESSION,
  SET_FAILURE_SESSION,
  DELETE_SESSION_FROM_LIST,
  ADD_SESSION_TO_LIST,
} from "../../../action/messages/list/listType";

const initalState = {
  messages: [],
  sessions: [],

  filtered: {
    searchedValue: "",
    list: [],
  },

  loading: false,
  loadingSessions: false,

  error: null,
  errorSessions: false,

  loaded: false,
  loadedSessions: false,

  deleteLoading: false,
  deleteError: null,
};

const messagesListReducer = (state = initalState, action) => {
  switch (action.type) {
    case SET_LOADING_MESSAGES:
      return {
        ...state,
        loading: true,
      };

    case SET_FAILURE_MESSAGES:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UNSET_LOADING_MESSAGES:
      return {
        ...state,
        loading: false,
      };

    case SET_FILTER_MESSEAGES:
      return {
        ...state,
        loading: false,
        filtered: {
          searchedValue: action.payload.value,
          list: action.payload.list,
        },
      };

    case SET_LIST_MESSAGES:
      return {
        ...state,
        messages: action.payload,
        loading: false,
        loaded: true,
        error: null,
      };

    case ADD_TO_LIST_MESSAGES:
      return {
        ...state,
        messages: [action.payload, ...state.messages],
      };

    case SET_LOADING_DELETE:
      return {
        ...state,
        deleteLoading: action.payload,
      };

    case SET_FAILURE_DELETE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.payload,
      };

    case SET_SUCCESS_DELETE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: null,
        messages: state.messages.filter((item) => item.id != action.payload),
      };

    case SEEN_MESSAGE_ITEM_COUNT:
      return {
        ...state,
        messages: [
          ...state.messages.map((item) => {
            if (item.id === action.payload) {
              item.unseen_count = 0;
            }

            return item;
          }),
        ],
      };

    case RESTE_ALL_MESSAGES_LIST_DATA_APP:
      return {
        ...state,
        ...initalState,
      };

    case SET_LIST_SESSION:
      return {
        ...state,
        sessions: action.payload,
        loadingSessions: false,
        loadedSessions: true,
        errorSessions: null,
      };

    case SET_LOADING_SESSION:
      return {
        ...state,
        loadingSessions: true,
      };

    case SET_FAILURE_SESSION:
      return {
        ...state,
        loading: false,
        errorSessions: action.payload,
      };

    case DELETE_SESSION_FROM_LIST:
      const newdata = {
        data: state.sessions.data.filter(
          (session) => session.id != action.payload,
        ),
        pagination: state.sessions.pagination,
      };

      return {
        ...state,
        sessions: newdata,
      };

    case ADD_SESSION_TO_LIST:
      return {
        ...state,
        sessions: {
          ...state.sessions,
          data: [action.payload, ...state.sessions.data],
        },
      };

    default:
      return state;
  }
};

export default messagesListReducer;
